import $ from 'jquery';

export const checkCookies = () => {
    let terms = getCookies('terms');
    if (terms === '') {
        setTimeout(() => {
            document.querySelector('.cookies').classList.remove('cookies--hide');
        }, 200);
    }

    document.querySelector('.cookies__btn').addEventListener('click', () => {
        setCookies('terms', 'true', 365);
    });    
};

export const setCookies = (cname, cvalue, exdays) => {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires='+d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    setTimeout(() => {
        document.querySelector('.cookies').classList.add('cookies--hide');
    }, 200);
};

export const getCookies = (cookieName) => {
    let name = cookieName + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export const showContentBlockedByCookies = () => {
    const blockedContent = $('.main-container').find('[data-cookieconsent]')

    if ($(blockedContent).length > 0 && typeof Cookiebot !== 'undefined' && Cookiebot.consent != null) {
        $(blockedContent).each(function(_index, content) {
            const cookiesTypes = $(content).attr('data-cookieconsent').split(',')
            let optoutClass = ''
            let cookiesConsent = []
    
            cookiesTypes.forEach(type => {
                optoutClass += `cookieconsent-optout-${type} `
                cookiesConsent.push(Cookiebot.consent[type])
            })

            if (cookiesConsent.includes(false)) {
                const blockedMessage = `
                    <div class="${optoutClass}">
                        <div class="cookies-blocked">
                            <div>${window.cookieMessageText.replace('{cookiesTypes}', cookiesTypes.join(', '))}</div>
                            <a href="javascript:Cookiebot.renew()" title="${window.cookieMessageLink}">${window.cookieMessageLink}</a>
                        </div>
                    </div>`
        
                $(content).after(blockedMessage)
            }
        })
    }
}
